var exports = {
  "kL": "xe564cbfb--40e897--container",
  "yJ": "xe564cbfb--40e897--links",
  "PD": "xe564cbfb--40e897--links--expanded",
  "UI": "xe564cbfb--40e897--links-block",
  "hJ": "xe564cbfb--40e897--counter",
  "nf": "xe564cbfb--40e897--link",
};

module.exports = exports;
